import React from "react";
import Dashboard from "./Dashboard.jsx";

function App() {
  return <Dashboard />;
}

export default App;
